import en from './en';
import es from './es';

export default {
  en,
  es
};
